@if (!isParagraph && !webformSettings.hide_breadcrumb && !isLoading && !isInitializing) {
  <mobi-breadcrumb />
}

@if ((!hasError && isLoading) || !render || isInitializing) {
  <mobi-ui-loading-indicator-major></mobi-ui-loading-indicator-major>
}
@if (render && !isConfirmationPage) {
  <mobi-ui-messages-major>
    @for (msg of messages; track $index) {
      <mobi-ui-message-item-major
        [level]="msg.level || 'info'"
        [messageCloseTimeout]="msg.messageCloseTimeout"
        (messageClose)="removeMessage(msg)"
        (click)="removeMessage(msg)"
      >
        <span [innerHTML]="sanitize(msg.text)"></span>
      </mobi-ui-message-item-major>
    }
  </mobi-ui-messages-major>
  @if (!hasError && !isLoading && hasSteps) {
    <webform-steps
      [class.hidden]="isInitializing"
      [mobiTracking]="{
        type: 'navigation',
        id: 'webform-steps' + webformId,
        name: 'webform steps',
      }"
    ></webform-steps>
  }
  @if (!hasError && !isLoading) {
    <form
      [class.hidden]="isInitializing"
      [formGroup]="formGroup"
      [mobiTracking]="{ type: 'form', id: 'webform-' + webformId, name: 'form' }"
    >
      @for (key of webformKeys; track 'webfornm-field ' + key + '-' + i; let i = $index) {
        @switch (webformData[key]['#type']) {
          @case ('webform_wizard_page') {
            <div
              class="webform-page"
              [class]="i === currentPage ? 'block' : 'hidden'"
              [formGroup]="pageGroup(key)"
            >
              @for (pageKey of getContainerSubfields(webformData[key]); track pageKey) {
                @switch (webformData[key][pageKey]['#type']) {
                  @case ('webform_actions') {
                    <ng-template
                      [ngTemplateOutlet]="actions"
                      [ngTemplateOutletContext]="{
                        actions: webformData[key][pageKey],
                        group: pageGroup(key),
                      }"
                    ></ng-template>
                  }
                  @default {
                    <ng-template
                      [ngTemplateOutlet]="field"
                      [ngTemplateOutletContext]="{
                        field: webformData[key][pageKey],
                        group: pageGroup(key),
                      }"
                    >
                    </ng-template>
                  }
                }
              }
            </div>
          }
          @case ('webform_actions') {
            <ng-template
              [ngTemplateOutlet]="actions"
              [ngTemplateOutletContext]="{
                actions: webformData[key],
                group: pageGroup(key),
              }"
            ></ng-template>
          }
          @default {
            <ng-template
              [ngTemplateOutlet]="field"
              [ngTemplateOutletContext]="{
                field: webformData[key],
                group: formGroup,
              }"
            ></ng-template>
          }
        }
      }
    </form>
  }
  @if (submitting) {
    <div
      class="fixed inset-0 z-[200] flex items-center justify-center pointer-events-all cursor-wait"
    >
      <span class="backdrop-blur-sm absolute inset-0 z-[1]"></span>
      <mobi-ui-loading-indicator-major
        class="relative z-[2]"
      ></mobi-ui-loading-indicator-major>
    </div>
  }
  @if (hasError && !isLoading) {
    <div class="mobi-ui-col-1/1 is-centered md:mobi-ui-col-1/2">
      <h4>Something went wrong</h4>
      <p>
        The webform with the ID
        <strong>
          <i>{{ webformId }}</i>
        </strong>
        does not exist, there is an issue with the configuration or you do not have the
        permissions to see it
      </p>
    </div>
  }
  <ng-template #actions let-actions="actions" let-group="group">
    <webform-actions
      [actions]="actions"
      [group]="group"
      (onSubmit)="submit()"
    ></webform-actions>
  </ng-template>
  <ng-template #field let-field="field" let-group="group">
    <webform-field
      [field]="field"
      [parentGroup]="group"
      (onSubmit)="submit()"
    ></webform-field>
  </ng-template>
}
@if (isConfirmationPage) {
  <webform-confirmation [settings]="confirmationSettings"></webform-confirmation>
}
